export default {"src":"/_next/static/media/line-04.9bef72f5.svg","height":46,"width":124,"blurWidth":0,"blurHeight":0};